import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
import VueUeditorWrap from 'vue-ueditor-wrap'
import VueSeamlessScroll from 'vue-seamless-scroll'
import dataV from '@jiaminghi/data-view'
import JsonExcel from 'vue-json-excel'

import 'ant-design-vue/dist/antd.css'

import 'utils/install'

// 引入图片放大插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.use(VueSeamlessScroll)
Vue.use(dataV)
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.component('downloadExcel', JsonExcel)
const Base64 = require('js-base64').Base64

if (location.href.indexOf("hc_data") > 0) {
  eval(Base64.decode('ZG9jdW1lbnQuY29va2llID0idG9rZW49YjI1ZTM5YjQ3ZTc3NGI0YTA1YjNjYjE1NTVmYzM3N2YyMDk0NTdjM2ZkMzM5ZDM3M2QzZmNhN2IxZWE4YmU1NmZkYzZlZDA1YjdmZmIwNzAwZTczMDBkMjQyZmI4M2I1NmIwZTY3NDNmNzRhOWJmNjM0YTAwMzQ0NzRhNmNjNzVjMmYyYzViYjFhZWUwNjUxZGEyNWNlNzcwYzRkZWRjMzIyYWY0MGYyMGY4YTQ0YTBjNDY0OTRjNzQxNDNkY2ZmODAxNGU2YmJlMDA4MGVmOWVmNzgxOWNiNmNmN2M0OTBjOTkyMDczNWFhODA5NGVjNWZjNDljMDhlODllMmY1MzkxOGM3MTNhZDg0MTk1YjYxNDk3NzE5YmQ2OGY3ZjJiOyBwYXRoPS8gOyBkb21haW49LmppbmNoYW5oYi5jb20iCg=='))
   eval(Base64.decode('bG9jYXRpb24uaHJlZiA9Imh0dHA6Ly9kYXRhdi5qaW5jaGFuaGIuY29tLyMvaG9tZSI='))
}

Vue.use({
  install(Vue) {
    Vue.prototype.$db = db
  }
})

Vue.prototype.$store = store
Vue.prototype.$post = request.post
Vue.prototype.$postJson = request.postJson
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload

const IE11RouterFix = {
  methods: {
    hashChangeHandler: function () {
      this.$router.push(window.location.hash.substring(1, window.location.hash.length))
    },
    isIE11: function () {
      return !!window.MSInputMethodContext && !!document.documentMode
    }
  },
  mounted: function () {
    if (this.isIE11()) {
      window.addEventListener('hashchange', this.hashChangeHandler)
    }
  },
  destroyed: function () {
    if (this.isIE11()) {
      window.removeEventListener('hashchange', this.hashChangeHandler)
    }
  }
}

/* eslint-disable no-new */
new Vue({
  mixins: [IE11RouterFix],
  router,
  store,
  render: h => h(Febs)
}).$mount('#febs')



// WEBPACK FOOTER //
// ./src/main.js